export const Experiance = [
  {
    period: "09/2022 - and counting.",
    title: "FULLSTACK DEVELOPER - ",
    place: "ANJ AMERICA",
    description:
      "Collaborated with designers to create clean, responsive user interfaces, ensuring simple, intuitive interactions and seamless user experiences. Developed and maintained robust back-end systems, integrating APIs, databases, and server-side logic to ensure efficient, scalable, and secure full-stack web applications.",
  },
  {
    period: "05/2022 - 09/2022 ",
    title: "WEB DEVELOPER INTERN -  ",
    place: "ANJ AMERICA",
    description:
      "Developed some real world projects, created user interfaces that are responsive.  Developed and maintained robust back-end systems, integrating APIs, databases, and server-side logic to ensure efficient, scalable, and secure full-stack web applications.",
  },
  {
    period: "09/2022 - 01/2022",
    title: "MOBILE APP DEVELOPER",
    place: "CONNECT EMEA",
    description:
      "Created a mobile app for the college management system. Admin has access to all student and faculty data.",
  },
];
